const TOKEN_KEY = "merchant_token";
const USER_KEY = "merchant_user";

export type MerchantUser = {
  id: number;
  account: string;
  displayName: string | null;
  paymentMerchantId?: string | null;
  env: string;
};

export type LoginResult = {
  token: string;
  expiresAt: string;
  env: string;
  user: MerchantUser;
};

export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredUser(): MerchantUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as MerchantUser;
  } catch {
    return null;
  }
}

export function setSession(token: string, user: MerchantUser) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
